
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  AIGroup,
  Answer,
  FingerCheckResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import {
  CandidateNewResult,
  ColorDetectionConfig,
  DimensionGroupConfig,
  HandDetectionConfig
} from "@/lib/model/exam/candidate-result";
import ResultSuccess from "../assets/result-success.svg";
import ResultReject from "../assets/result-reject.svg";
import ResultTobe from "../assets/result-tobe.svg";

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];
const errorEnumTextEX = {
  bgCheckIdentity: ["手机号实名未查询", "手机号实名异常", "通过"],
  bgCheckFinancial: ["综合B类评估未检测", "综合B类评估异常", "通过"],
  bgCheckSocial: ["综合A类评估未检测", "综合A类评估异常", "通过"],
  faceCheck: ["样本数量不足无法检测", "人脸核验异常", "通过"],
  replacePerson: ["样本数量不足无法检测", "换人检测异常", "通过"],
  faceDetection: ["样本数量不足无法检测", "露脸检测异常", "通过"],
  webJump: ["未进行防切屏检测", "切屏异常", "通过"],
  screenshot: ["未进行防截屏检测", "截屏异常", "通过"],
  mobileJoinCount: ["未进行防切屏检测", "切屏异常", "通过"]
};
const errorEnumName = {
  bgCheckIdentity: "手机号实名认证",
  bgCheckFinancial: "综合B类评估记录",
  bgCheckSocial: "综合A类评估记录",
  screenshot: "候选人防截屏",
  mobileJoinCount: "候选人防切屏",
  replacePerson: "换人检测",
  // webJump: "Web防切屏检测",
  faceDetection: "露脸检测",
  faceCheck: "人脸核验"
};
//手部
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}
enum dimResEnum {
  "差" = 0,
  "中" = 1,
  "优" = 2
}

@Component({})
export default class PaperResultReport extends Vue {
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop() index!: number;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;

  get hrResEnum() {
    const enumHr = {
      0: "",
      1: ResultSuccess,
      2: ResultTobe,
      3: ResultReject
    };
    return enumHr[this.all.candidateInfo.auditInfo.auditStatus] || "";
  }

  dimResEnum = dimResEnum;

  dimResText(i: number) {
    return {
      10: "欠佳",
      20: "中等",
      30: "优秀"
    }[i];
  }

  //这套先留着 后续可能改成使用远程svg，这套可以处理svg的颜色和大小
  // // 维度组logo
  groupLogoDefault =
    "https://oss.5kong.com/app/test/2024/08/09/5fb54f8af8dff72e21781fe2399f1894.svg";
  dimGroupLogo: { [key: string]: string } = {
    基础能力:
      "https://oss.5kong.com/app/test/2024/08/09/1e2068cbd987f58f152af259ffd1b1ab.svg",
    通用素质:
      "https://oss.5kong.com/app/test/2024/08/09/273c6e862da39b37573487eecee28f14.svg",
    岗位匹配度:
      "https://oss.5kong.com/app/test/2024/08/09/6939f97b064356007b1afe1cf1b8c3b2.svg",
    进阶能力:
      "https://oss.5kong.com/app/test/2024/08/09/8b4bfac27a47a3147d51b1a56a55cac1.svg",
    其他:
      "https://oss.5kong.com/app/test/2024/08/09/5fb54f8af8dff72e21781fe2399f1894.svg"
  };
  dimGroupLogoSvg: { [key: string]: string } = {};

  getDimGroupLogoSvg(name: string, color: string, size = 56) {
    if (!name) return "";
    const url = this.getDimGroupLogoUrl(name);
    this.getFetchSvg(url, color, size).then(res => {
      // this.dimGroupLogoSvg[name] = res as string;
      res = `${res}`;
      this.$set(this.dimGroupLogoSvg, name, res);
      return res;
    });
  }
  getDimGroupLogoUrl(name: string) {
    if (!name) return this.groupLogoDefault;
    return this.dimGroupLogo?.[name] || this.groupLogoDefault;
  }

  async getFetchSvg(url: string, color: string, size: number) {
    if (!url) return;
    try {
      const response = await fetch(url);
      if (response.ok) {
        const svgText = await response.text();
        const res = svgText
          .replace(/fill="[^"]*"/g, 'fill="' + color + '" fill-opacity="0.12"')
          .replace(/<svg[^>]*>/, match => {
            // 确保宽高属性被添加或替换
            if (match.includes("width") || match.includes("height")) {
              return match
                .replace(/width="[^"]*"/, 'width="' + size + 'px"')
                .replace(/height="[^"]*"/, 'height="' + size + 'px"');
            } else {
              return match.replace(
                "<svg",
                '<svg width="' + size + 'px" height="' + size + 'px"'
              );
            }
          });
        return res;
      } else {
        console.error("Failed to fetch SVG:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching SVG:", error);
    }
  }

  //10 20 30 分三档时 颜色值
  getColor30(dim: DimensionGroupConfig) {
    return dim.dimensionGroupLevel === 30
      ? "#1db26f"
      : dim.dimensionGroupLevel === 20
      ? "#FF9900"
      : "#eb462d";
  }

  //是否分组展示
  public get isGroup() {
    return true;
  }
  //模块展示
  public Show(p: string) {
    return true;
  }
  //手指检测109
  get finger() {
    return this.all.report.handDetection || new HandDetectionConfig();
  }
  get colorAnswer() {
    return this.all.report.colorDetection || new ColorDetectionConfig();
  }

  // 类普工版要求这些考察项结果在此按照配置顺序罗列出来
  workVersionShowTestName = [
    "手部综合检测",
    "辩色检测",
    "背景调查",
    "游戏测评打气球",
    "维度分析",
    "DVF1.0心理风险测量",
    "作弊风险检测"
  ];
  workSortTestList: {
    name: string;
    result: number;
    content: string;
    text: string;
    color: string;
    iconRevert?: number;
    showRession?: boolean;
  }[] = [];

  groupLogo =
    "https://oss.hina.com/app/hina/2023/06/25/1aa4eff607c642b6c6aba3b4d16baedc.svg"; //兜底图标

  created() {
    //
    if (this.option.versionId === 1) {
      this.all.reportShowConfigV5.forEach(item => {
        if (this.workVersionShowTestName.includes(item.name)) {
          this.addWorkTestList(item.name);
        }
      });
    }
  }

  dimensionGroupList: any[] = [];

  //
  mounted() {
    this.dimensionGroupList = this.all.report.dimensionGroupList.filter(
      item => item.showOverview === 1
    );
    //
    this.dimensionGroupList.forEach(item => {
      this.getDimGroupLogoSvg(item.groupName, this.getColor30(item), 36);
    });
  }

  fingerResText(i: number) {
    if (this.all.report.handDetection.answerNumber === 0) {
      return "候选人未作答";
    }
    return enumFinger[i];
  }

  getColorText() {
    if (this.colorAnswer.blindnessResult === 2) {
      return "色盲";
    } else if (this.colorAnswer.weaknessResult === 2) {
      return "色弱";
    } else {
      return "";
    }
  }

  addWorkTestList(name: string) {
    const fingerIsAnswerd = this.all.report.handDetection.answerNumber > 0;
    const colorIsAnswerd = this.colorAnswer.answerNumber > 0;
    switch (name) {
      case "手部综合检测":
        if (this.all.report.handDetection) {
          if (this.finger.resultComplete !== 255) {
            this.workSortTestList.push({
              name: "手部完整度",
              result: this.finger.resultComplete,
              content: this.fingerResText(this.finger.resultComplete),
              color: !fingerIsAnswerd
                ? "yellow"
                : this.finger.resultComplete === 1
                ? "green"
                : this.finger.resultComplete === 2
                ? "red"
                : "yellow",
              text: !fingerIsAnswerd
                ? "未检测"
                : this.getText(this.finger.resultComplete)
            });
          }
          if (this.finger.resultFlexible !== 255) {
            this.workSortTestList.push({
              name: "灵活度检测",
              result: this.finger.resultFlexible,
              content: this.fingerResText(this.finger.resultFlexible),
              color: !fingerIsAnswerd
                ? "yellow"
                : this.finger.resultFlexible === 1
                ? "green"
                : this.finger.resultFlexible === 2
                ? "red"
                : "yellow",
              text: !fingerIsAnswerd
                ? "未检测"
                : this.getText(this.finger.resultFlexible)
            });
          }
          if (this.finger.resultScar !== 255) {
            this.workSortTestList.push({
              name: "疤痕与纹身",
              result: this.finger.resultScar,
              content: this.fingerResText(this.finger.resultScar),
              color: !fingerIsAnswerd
                ? "yellow"
                : this.finger.resultScar === 1
                ? "green"
                : this.finger.resultScar === 2
                ? "red"
                : "yellow",
              text: !fingerIsAnswerd
                ? "未检测"
                : this.getText(this.finger.resultScar)
            });
          }
        }
        break;
      case "辩色检测":
        this.all.report.errorInfoList.forEach(item => {
          if (item.task === "colorDetection") {
            this.workSortTestList.push({
              color: !colorIsAnswerd
                ? "yellow"
                : item.result === 1
                ? "red"
                : item.result === 0
                ? "yellow"
                : "green",
              result: item.result,
              name: "辨色检测",
              content: !colorIsAnswerd
                ? "候选人未作答"
                : this.getColorText() || errorEnumText[item.result],
              text: !colorIsAnswerd
                ? "未检测"
                : this.getColorText() || errorEnumText[item.result],
              iconRevert: this.errorIconRevert(item.result)
            });
          }
        });
        break;
      case "背景调查":
        this.all.report.errorInfoList.forEach(item => {
          if (
            ["bgCheckIdentity", "bgCheckFinancial", "bgCheckSocial"].includes(
              item.task
            )
          ) {
            this.workSortTestList.push({
              color:
                item.result === 1
                  ? "red"
                  : item.result === 0
                  ? "yellow"
                  : "green",
              result: item.result,
              name: errorEnumName[item.task],
              content:
                item.resMessage ||
                errorEnumTextEX?.[item.task]?.[item.result] ||
                errorEnumText[item.result],
              text: errorEnumText[item.result],
              iconRevert: this.errorIconRevert(item.result),
              showRession: item.result === 1 && item.task !== "bgCheckIdentity"
            });
          }
        });
        break;
      case "维度分析":
        this.all.report.dimensionReportList.forEach(item => {
          this.workSortTestList.push({
            color:
              // item.unanswered === 1
              //   ? "yellow"
              //   :
              item.dimensionLevel === 10 ? "red" : "green",
            result: 0,
            name: item.dimensionName,
            content: "",
            text:
              // item.unanswered === 1 ? "未作答" :
              item.dimensionLevelDesc,
            iconRevert:
              // item.unanswered === 1 ? 0 :
              item.dimensionLevel === 10 ? 2 : 1
          });
        });
        break;
      case "作弊风险检测":
        this.all.report.errorInfoList.forEach(item => {
          if (
            [
              "screenshot",
              "mobileJoinCount",
              "replacePerson",
              // "webJump",
              "faceDetection",
              "faceCheck"
            ].includes(item.task)
          ) {
            this.workSortTestList.push({
              color:
                item.result === 1
                  ? "red"
                  : item.result === 0
                  ? "yellow"
                  : "green",
              result: item.result,
              name: errorEnumName[item.task],
              content:
                item.resMessage ||
                errorEnumTextEX?.[item.task]?.[item.result] ||
                errorEnumText[item.result],
              text: errorEnumText[item.result],
              iconRevert: this.errorIconRevert(item.result)
            });
          }
        });
        break;
    }
  }

  errorIconRevert(result: number) {
    return {
      0: 0,
      1: 2,
      2: 1
    }[result];
  }

  getIconFontClassMap = {
    0: "&#xe6c0;", // yellow
    1: "&#xe6cc;", // green
    2: "&#xe6bf;" // red
  };

  getText(i: number) {
    return ["未检测", "通过", "未通过"][i];
  }
}
